import React from 'react';
import './placementlist.css';

const Placementlist = () => {
  const students = [
    
      {
        "name": "MUKESH KUMAR",
        "course": "MBA",
        "company": "TOYOTA",
        "designation": "SSE+AWS",
        "package": "30 LPA",
        "image": "https://via.placeholder.com/150"
      },
      {
        "name": "ROOP SINGH RAWAT",
        "course": "B. TECH. ME",
        "company": "MINDA GROUP",
        "designation": "Deputy Manager Quality",
        "package": "20 LPA",
        "image": "https://via.placeholder.com/150"
      },
      {
        "name": "Amit Kumar",
        "course": "B. TECH. ME",
        "company": "Mitshubishi",
        "designation": "Sr. Manager",
        "package": "20 LPA",
        "image": "https://via.placeholder.com/150"
      },
      {
        "name": "HARIOM",
        "course": "MBA",
        "company": "J. D. GROUP",
        "designation": "CHIEF OFFICER",
        "package": "17 LPA",
        "image": "https://via.placeholder.com/150"
      },
      {
        "name": "Utkarsh Dhody",
        "course": "B. TECH. ME",
        "company": "Global Hydro GMBH",
        "designation": "Project Manager",
        "package": "17 LPA",
        "image": "https://via.placeholder.com/150"
      },
      {
        "name": "Naveen Bhardwaj",
        "course": "B. TECH. CIVIL",
        "company": "Mahendra Raj Consultants Pvt.Ltd.",
        "designation": "Sr.Structure Design Engineer",
        "package": "15 LPA",
        "image": "https://via.placeholder.com/150"
      },
      {
        "name": "Pramod Kumar",
        "course": "B. TECH. EE",
        "company": "IR class new delhi",
        "designation": "Sr. Engineer",
        "package": "13 LPA",
        "image": "https://via.placeholder.com/150"
      },
      {
        "name": "Nitish Patel",
        "course": "B. TECH. ME",
        "company": "L&T Defence",
        "designation": "Design Engineer",
        "package": "12 LPA",
        "image": "https://via.placeholder.com/150"
      },
      {
        "name": "Shahbaz Alam",
        "course": "B. TECH. EE",
        "company": "RINA D'Appolonia SPA, Italy EU",
        "designation": "Energy Consultant & Electrical Engineer",
        "package": "11 LPA",
        "image": "https://via.placeholder.com/150"
      },
      {
        "name": "Gourav Singh",
        "course": "B. TECH. ME",
        "company": "Escorts kubota limited",
        "designation": "Manager",
        "package": "11 LPA",
        "image": "https://via.placeholder.com/150"
      },
      
        {
          "name": "Nassir Hussain",
          "course": "BBA",
          "company": "Kataria limited",
          "designation": "Employee",
          "package": "10 LPA",
          "image": "https://via.placeholder.com/150"
        },
        {
          "name": "Vineet",
          "course": "DIPLOMA CSE",
          "company": "Microsoft",
          "designation": "System Analysis",
          "package": "10 LPA",
          "image": "https://via.placeholder.com/150"
        },
        {
          "name": "Kapil Balodi",
          "course": "B. TECH. ME",
          "company": "Sphinx Worldbiz LTD",
          "designation": "Senior Design Engineer",
          "package": "10 LPA",
          "image": "https://via.placeholder.com/150"
        },
        {
          "name": "Pankaj Sharma",
          "course": "B. TECH. EE",
          "company": "Surbana Jurong India pvt ltd",
          "designation": "Assistant Cost Manager",
          "package": "10 LPA",
          "image": "https://via.placeholder.com/150"
        },
        {
          "name": "Vikas Kumar",
          "course": "B. TECH. ME",
          "company": "SYSTRA PVT LTD",
          "designation": "Engineer",
          "package": "9.5 LPA",
          "image": "https://via.placeholder.com/150"
        },
        {
          "name": "Rinku Kumar",
          "course": "B. TECH. CSE",
          "company": "Tata Consultancy Services",
          "designation": "Subject Matter Expert",
          "package": "9.5 LPA",
          "image": "https://via.placeholder.com/150"
        },
        {
          "name": "Himanshu Rana",
          "course": "B. TECH. ME",
          "company": "Maruti Suzuki",
          "designation": "Sr. Engineer",
          "package": "9.3 LPA",
          "image": "https://via.placeholder.com/150"
        },
        {
          "name": "Vivek Sharma",
          "course": "DIPLOMA ME",
          "company": "M/s Loesche India Pvt. Ltd.",
          "designation": "Sr. Engineer",
          "package": "9 LPA",
          "image": "https://via.placeholder.com/150"
        },
        {
          "name": "Adarsh Rawat",
          "course": "DIPLOMA CSE",
          "company": "Six Sails Technologies Pvt Ltd",
          "designation": "Software Engineer",
          "package": "8 LPA",
          "image": "https://via.placeholder.com/150"
        },
        {
          "name": "Nitika",
          "course": "MBA",
          "company": "DEL DEVELOPMENT",
          "designation": "Asst. Manager",
          "package": "8.8 LPA",
          "image": "https://via.placeholder.com/150"
        },
          {
            "name": "Kadam Kapil",
            "course": "B. TECH. ME",
            "company": "AECOM India Global Services Pvt. Ltd",
            "designation": "BIM Specialist",
            "package": "8 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Issrar",
            "course": "B. TECH. ME",
            "company": "Kr auto component pvt Ltd",
            "designation": "Senior Designer",
            "package": "7.8 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Surya Pratap Singh",
            "course": "B. TECH. CIVIL",
            "company": "Tata Project Ltd",
            "designation": "Quality Engineer",
            "package": "7.20 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Jatin Kaushik",
            "course": "B. TECH. ME",
            "company": "Daikin airconditioner pvt Ltd",
            "designation": "Engineer (R&D)",
            "package": "7 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Sachin Pratap",
            "course": "MBA",
            "company": "Cendyn India pat",
            "designation": "Software Developer",
            "package": "7 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Sagar",
            "course": "BCA",
            "company": "Wipro",
            "designation": "Web Development",
            "package": "6 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Saloni Choudhary",
            "course": "B. TECH. ME",
            "company": "Uno Minda limited",
            "designation": "Sr. Engineer",
            "package": "6 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Gurudutt",
            "course": "B. TECH. ME",
            "company": "Maruti Suzuki",
            "designation": "Executive",
            "package": "6 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Abhishek Tiwari",
            "course": "DIPLOMA EE",
            "company": "L&T Defence",
            "designation": "Design Engineer",
            "package": "6 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Nitin",
            "course": "B. TECH. CSE",
            "company": "SBI CARDS AND PVT LTD",
            "designation": "Branch Relationship Executive",
            "package": "6 LPA",
            "image": "https://via.placeholder.com/150"
        },
          {
            "name": "Aakash Kushwaha",
            "course": "B. TECH. ME",
            "company": "Falcon Autotech",
            "designation": "Design Engineer/Engineer",
            "package": "6 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Utkarsh Sanger",
            "course": "B. TECH. CIVIL",
            "company": "VCL Group",
            "designation": "QA/QC Engineer",
            "package": "6 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Sagar",
            "course": "B. TECH. CIVIL",
            "company": "Kalpataru Projects",
            "designation": "Assistant Engineer",
            "package": "6 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Prem Sagar",
            "course": "B. TECH. EE",
            "company": "Avaada Giga",
            "designation": "Junior Engineer",
            "package": "5.8 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Anamika Singh",
            "course": "B. TECH. ECE",
            "company": "Ultratech",
            "designation": "DET",
            "package": "5.8 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Vineet Kumar",
            "course": "B. TECH. ME",
            "company": "Venus Industrial Corporation Ltd.",
            "designation": "Product Engineer",
            "package": "5.7 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Girish Das",
            "course": "B. TECH. CSE",
            "company": "IT Sector",
            "designation": "Engineer",
            "package": "5.6 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Pankaj Mani",
            "course": "B. TECH. CIVIL",
            "company": "Road Construction",
            "designation": "Civil Engineering",
            "package": "5.65 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Ajay Kumar",
            "course": "B. TECH. CIVIL",
            "company": "China Petroleum Engineering and Construction Corporation",
            "designation": "Quality Engineer - Civil",
            "package": "5.4 LPA",
            "image": "https://via.placeholder.com/150"
          },
          {
            "name": "Chandresh Rao",
            "course": "B. TECH. EE",
            "company": "Denso Ten Uno Minda",
            "designation": "Associate",
            "package": "5.3 LPA",
            "image": "https://via.placeholder.com/150"
          },
         {
              "name": "Deepak",
              "course": "B. TECH. ME",
              "company": "Escorts Kubota Limited",
              "designation": "DET",
              "package": "5.32 LPA",
              "image": "https://via.placeholder.com/150"
            },
            {
              "name": "Manish",
              "course": "B. TECH. EE",
              "company": "MRM Procom Pvt Ltd",
              "designation": "Engineer",
              "package": "5.30 LPA",
              "image": "https://via.placeholder.com/150"
            },
            {
              "name": "Vashudev",
              "course": "B. TECH. ME",
              "company": "Flowcon Auto System Pvt Ltd, Jharsently Sec 59",
              "designation": "—",
              "package": "5.2 LPA",
              "image": "https://via.placeholder.com/150"
            },
            {
              "name": "Pawan Saini",
              "course": "B. TECH. ME",
              "company": "Escorts Kubota Pvt. Ltd",
              "designation": "Technician",
              "package": "5.1 LPA",
              "image": "https://via.placeholder.com/150"
            },
            {
              "name": "Roshan Pandey",
              "course": "B. TECH. ECE",
              "company": "Delton Cable Limited",
              "designation": "Junior Engineer",
              "package": "5 LPA",
              "image": "https://via.placeholder.com/150"
            },
            {
              "name": "Rahul Kumar",
              "course": "B. TECH. ME",
              "company": "LAPP India",
              "designation": "Engineer",
              "package": "5 LPA",
              "image": "https://via.placeholder.com/150"
            },
            {
              "name": "Sandeep Kumar",
              "course": "B. TECH. ME",
              "company": "Brand Recourse Technology Pvt Ltd",
              "designation": "Zone Incharge (Team Leader)",
              "package": "5 LPA",
              "image": "https://via.placeholder.com/150"
            },
            {
              "name": "Gaurav",
              "course": "B. TECH. ME",
              "company": "Escorts Kubota Limited",
              "designation": "Executive",
              "package": "5 LPA",
              "image": "https://via.placeholder.com/150"
            },
            {
              "name": "Shubham Sharma",
              "course": "B. TECH. ME",
              "company": "Ms. Mach Automation and Solutions",
              "designation": "Design Engineer",
              "package": "5 LPA",
              "image": "https://via.placeholder.com/150"
            },
            {
              "name": "Tushar Sharma",
              "course": "DIPLOMA ME",
              "company": "Shivalic",
              "designation": "Supervisor",
              "package": "5 LPA",
              "image": "https://via.placeholder.com/150"
            },
              {
                "name": "Chandan Kumar Keshri",
                "course": "B. TECH. ME",
                "company": "Protomac Extrusion Pvt. Limited",
                "designation": "Mechanical Design Engineer",
                "package": "5 LPA",
                "image": "https://via.placeholder.com/150"
              },
              {
                "name": "Shyam Sunder",
                "course": "B. TECH. ME",
                "company": "Dee Development Engineering",
                "designation": "Junior Engineer",
                "package": "5 LPA",
                "image": "https://via.placeholder.com/150"
              },
              {
                "name": "Krishan",
                "course": "B. TECH. ME",
                "company": "Intenco Engineering",
                "designation": "Site Incharge",
                "package": "5 LPA",
                "image": "https://via.placeholder.com/150"
              },
              {
                "name": "Badal",
                "course": "B. TECH. ME",
                "company": "Inex Design",
                "designation": "Designing and Programming",
                "package": "5 LPA",
                "image": "https://via.placeholder.com/150"
              },
              {
                "name": "Saurabh Kumar",
                "course": "B. TECH. ME",
                "company": "JSW",
                "designation": "JE",
                "package": "5 LPA",
                "image": "https://via.placeholder.com/150"
              },
              {
                "name": "Sachin Rattan",
                "course": "B. TECH. EE",
                "company": "Sanden Vikas",
                "designation": "Trainee",
                "package": "5 LPA",
                "image": "https://via.placeholder.com/150"
              },
              {
                "name": "Kapil",
                "course": "DIPLOMA ME",
                "company": "Good Year Tyre",
                "designation": "Production Supervisor",
                "package": "5 LPA",
                "image": "https://via.placeholder.com/150"
              },
              {
                "name": "Rakesh",
                "course": "DIPLOMA EE",
                "company": "JCB",
                "designation": "L1",
                "package": "5 LPA",
                "image": "https://via.placeholder.com/150"
              },
              {
                "name": "Yaseen",
                "course": "B. TECH. ME",
                "company": "Svarn Infratel",
                "designation": "Engineer",
                "package": "5 LPA",
                "image": "https://via.placeholder.com/150"
              },
              {
                "name": "Kailash",
                "course": "B. TECH. ME",
                "company": "Lumax",
                "designation": "Operating Engineer",
                "package": "5 LPA",
                "image": "https://via.placeholder.com/150"
              }
            
          
          
        
        
      
      
    
  ];

  return (
    <div className="main-container-placement-list">
      <div className="container-placement-list">
        <h1>Placement Record</h1>
        <div className="card-container">
          {students.map((student, index) => (
            <div className="card" key={index}>
              <img src={student.image} alt={student.name} className="student-image" />
              <div className="student-details">
                <h2>{student.name}</h2>
                <p><strong>Company:</strong> {student.company}</p>
                <p><strong>Course:</strong> {student.course}</p>
                <p><strong>Designation:</strong> {student.designation}</p>
                <p><strong>Package:</strong> {student.package}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Placementlist;
